module.exports = __webpack_public_path__ + "static/3-4dec992a71f9b05ad014d0eaf9633cb6.jpg";